import { createRouter, createWebHistory } from 'vue-router'
// import { useBreadCrumbStore } from '../stores/breadcrumb_store';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('../views/auth-views/LoginView.vue'),
    },

    {
      path: '/support',
      name: 'support',
      component: () => import('../views/SupportView.vue'),
    },

    {
      path: '/forgot-password',
      name: 'forgotpassword',
      component: () => import('../views/auth-views/ForgotPasswordPage.vue'),
    },

    {
      path: '/otp',
      name: 'otp',
      component: () => import('../views/auth-views/OTPView.vue'),
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('../views/auth-views/ChangePasswordView.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('../views/DashboardView.vue'),
        },

        // upload_documents
        {
          path: '/upload_documents',
          name: 'upload_documents',
          component: () => import('../views/UploadDocumentsView.vue'),
        },

        {
          path: '/documents/:documentsSubRoute',
          name: 'documents-sub-routes',
          component: () => import('../views/sub-views/RendererSubView.vue')
        },
        {
          path: '/myorder/:myorderSubRoute',
          name: 'myorder-sub-routes',
          component: () => import('../views/sub-views/RendererSubView.vue')
        },
        {
          path: '/message/:messageSubRoute',
          name: 'message-sub-routes',
          component: () => import('../views/sub-views/MessageView.vue')
        },
        // {
        //   path: '/message/:messageSubRoute',
        //   name: 'message-sub-routes',
        //   component: () => import('../views/sub-views/RendererSubView.vue')
        // },
        {
          path: '/admin/manageuser',
          name: 'admin-user-sub-routes',
          component: () => import('../views/admin/ManageUserView.vue')
        },
        {
          path: '/admin/level',
          name: 'admin-level-sub-routes',
          component: () => import('../views/admin/ManageLevelView.vue')
        },
      ]
    },


    {
      path: '/:pathMatch(.*)*',
      name: 'ErrorPage',
      component: () => import('../views/ErrorPage.vue')
    },


  ],
});

router.beforeEach((to, from, next) => {
  //   const authStore = useUserAuthStore();
  const isLoggedIn = localStorage.getItem("tokens")
  const authScreens = ['login', 'forgotpassword', 'change-password', 'otp']
  const excludedScreen = ['support']

  if (excludedScreen.includes(to.name)) {
    next()
  } else if (authScreens.includes(to.name) && isLoggedIn) {
    next({ name: "dashboard" }) // prevent to go back to login page after authentication
  } else if (!authScreens.includes(to.name) && !isLoggedIn) {
    next({ name: "login" })
  } else {
    next()
  }
})



export default router
